/* Practice questions written by CheckMOT from the Highway Code (GOV.UK, checked 17 Oct 2026). Not official DVSA questions. */
window.CMT_THEORY_TOPICS=[{"id": "alertness", "name": "Alertness"}, {"id": "attitude", "name": "Attitude"}, {"id": "safety-vehicle", "name": "Safety and your vehicle"}, {"id": "safety-margins", "name": "Safety margins"}, {"id": "hazard-awareness", "name": "Hazard awareness"}, {"id": "vulnerable", "name": "Vulnerable road users"}, {"id": "other-vehicles", "name": "Other types of vehicle"}, {"id": "vehicle-handling", "name": "Vehicle handling"}, {"id": "motorway", "name": "Motorway rules"}, {"id": "rules-of-road", "name": "Rules of the road"}, {"id": "signs", "name": "Road and traffic signs"}, {"id": "documents", "name": "Documents"}, {"id": "incidents", "name": "Incidents, accidents and emergencies"}, {"id": "vehicle-loading", "name": "Vehicle loading"}];
window.CMT_THEORY_QUESTIONS=[
{
"id": 1,
"t": "alertness",
"q": "On a long drive, how often does the Highway Code recommend taking a break of at least 15 minutes?",
"o": [
"Every hour",
"Every three hours",
"Only when you feel tired",
"Every two hours"
],
"a": 3,
"e": "Plan a break of at least 15 minutes after every two hours of driving.",
"r": "Rule 91",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule91"
},
{
"id": 2,
"t": "alertness",
"q": "Between which hours does the Highway Code say natural alertness is at its lowest, so long journeys are best avoided?",
"o": [
"6am and 9am",
"Midnight and 6am",
"8pm and 10pm",
"2pm and 4pm"
],
"a": 1,
"e": "Avoid long journeys between midnight and 6am, when natural alertness is at a minimum.",
"r": "Rule 91",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule91"
},
{
"id": 3,
"t": "alertness",
"q": "You feel sleepy driving on a motorway. Where should you NOT stop to rest?",
"o": [
"The hard shoulder",
"A service area",
"A motorway rest area",
"The next exit and a safe car park"
],
"a": 0,
"e": "If you feel sleepy, stop in a safe place, but never on the hard shoulder of a motorway.",
"r": "Rule 91",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule91"
},
{
"id": 4,
"t": "alertness",
"q": "When can a driver legally use a hand-held phone while driving?",
"o": [
"When driving below 20 mph",
"To call 999 or 112 in a genuine emergency when it's unsafe or impractical to stop",
"When stopped at red traffic lights",
"When the call is under one minute"
],
"a": 1,
"e": "The only exception to the hand-held ban is calling 999 or 112 in a genuine emergency when it is unsafe or impractical to stop.",
"r": "Rule 149",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule149"
},
{
"id": 5,
"t": "alertness",
"q": "You're stuck in a queue of stationary traffic. Can you use your hand-held phone?",
"o": [
"Yes, the car isn't moving",
"Yes, if the engine is switched off by stop-start",
"No, you are still classed as driving",
"Yes, but only to read messages"
],
"a": 2,
"e": "The hand-held ban still applies when you're stationary in traffic, for example at lights or in a queue.",
"r": "Rule 149",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule149"
},
{
"id": 6,
"t": "alertness",
"q": "A supervising driver sitting next to a learner wants to use a hand-held phone. What does the Highway Code say?",
"o": [
"It's fine, they aren't driving",
"They MUST NOT use it while supervising",
"It's fine on quiet roads",
"Only for navigation"
],
"a": 1,
"e": "The hand-held phone ban covers supervising a learner driver too.",
"r": "Rule 149",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule149"
},
{
"id": 7,
"t": "alertness",
"q": "Which of these is listed as a distraction to avoid while driving?",
"o": [
"Looking well ahead",
"Loud music",
"Checking your mirrors",
"Keeping both hands on the wheel"
],
"a": 1,
"e": "Avoid distractions such as loud music, which may mask other sounds.",
"r": "Rule 148",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule148"
},
{
"id": 8,
"t": "alertness",
"q": "Before moving off, what should you do after checking your mirrors?",
"o": [
"Sound your horn",
"Turn on the hazard lights",
"Flash your headlights",
"Look round to check the blind spots"
],
"a": 3,
"e": "Use all mirrors, then look round to check the blind spots, the areas your mirrors can't show.",
"r": "Rule 159",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule159"
},
{
"id": 9,
"t": "alertness",
"q": "What is the correct order to remember when changing direction or speed?",
"o": [
"Manoeuvre - Signal - Mirrors",
"Signal - Mirrors - Manoeuvre",
"Mirrors - Manoeuvre - Signal",
"Mirrors - Signal - Manoeuvre"
],
"a": 3,
"e": "Remember: Mirrors - Signal - Manoeuvre.",
"r": "Rule 161",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule161"
},
{
"id": 10,
"t": "alertness",
"q": "From what distance must you be able to read a modern number plate in good daylight?",
"o": [
"25 metres",
"20 metres",
"15 metres",
"10 metres"
],
"a": 1,
"e": "You MUST be able to read a number plate from 20 metres (20.5 metres for old-style plates), with glasses or lenses if you need them.",
"r": "Rule 92",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule92"
},
{
"id": 11,
"t": "alertness",
"q": "You're driving at night. What does the Highway Code say about tinted glasses?",
"o": [
"Do not use them if they restrict your vision",
"They help reduce dazzle, so wear them",
"Only use them on motorways",
"They are compulsory"
],
"a": 0,
"e": "At night or in poor visibility, do not use tinted glasses, lenses or visors if they restrict your vision.",
"r": "Rule 94",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule94"
},
{
"id": 12,
"t": "alertness",
"q": "You are dazzled by bright, low sunlight. What should you do?",
"o": [
"Speed up to get past it",
"Close one eye",
"Switch on your fog lights",
"Slow down, and if necessary stop"
],
"a": 3,
"e": "Slow down, and if necessary stop, if you are dazzled by bright sunlight.",
"r": "Rule 93",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule93"
},
{
"id": 13,
"t": "alertness",
"q": "Which health conditions MUST you report to the DVLA?",
"o": [
"Only conditions needing hospital treatment",
"Any condition likely to affect your driving",
"None, you just tell your doctor",
"Only eyesight problems"
],
"a": 1,
"e": "You MUST report to the DVLA any health condition likely to affect your driving.",
"r": "Rule 90",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule90"
},
{
"id": 14,
"t": "attitude",
"q": "What is the only reason the Highway Code gives for flashing your headlights?",
"o": [
"To let other road users know you're there",
"To let someone out of a junction",
"To thank another driver",
"To warn of a speed camera"
],
"a": 0,
"e": "Only flash your headlights to let other road users know you are there, never to send any other message.",
"r": "Rule 110",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule110"
},
{
"id": 15,
"t": "attitude",
"q": "Another driver flashes their headlights at you at a junction. What should you do?",
"o": [
"Pull out straight away",
"Use your own judgement and proceed carefully",
"Flash back to thank them",
"Sound your horn"
],
"a": 1,
"e": "Never assume flashing headlights is an invitation to go. Use your own judgement.",
"r": "Rule 111",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule111"
},
{
"id": 16,
"t": "attitude",
"q": "Someone is overtaking you. What should you do?",
"o": [
"Brake sharply",
"Keep a steady course and speed, slowing if necessary",
"Speed up so they can't cut in",
"Move towards the centre of the road"
],
"a": 1,
"e": "Maintain a steady course and speed, slowing down if necessary. Never obstruct drivers who wish to pass.",
"r": "Rule 168",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule168"
},
{
"id": 17,
"t": "attitude",
"q": "A driver overtakes you and pulls into the gap in front. What should you do?",
"o": [
"Flash your lights",
"Overtake them back",
"Close up to show you're annoyed",
"Drop back to keep a two-second gap"
],
"a": 3,
"e": "Drop back to maintain a two-second gap if someone overtakes and pulls into the gap in front of you.",
"r": "Rule 168",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule168"
},
{
"id": 18,
"t": "attitude",
"q": "You're driving a slow vehicle and a long queue has built up behind you. What should you do?",
"o": [
"Wave them past on a bend",
"Carry on, they can wait",
"Speed up beyond the limit",
"Pull in where it's safe and let traffic pass"
],
"a": 3,
"e": "Do not hold up a long queue. Check your mirrors and pull in where it's safe to let traffic pass.",
"r": "Rule 169",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule169"
},
{
"id": 19,
"t": "attitude",
"q": "When may you use your horn aggressively?",
"o": [
"Never",
"When someone blocks your driveway",
"When a driver is too slow at lights",
"When someone cuts you up"
],
"a": 0,
"e": "Use the horn only to warn others of your presence. Never sound it aggressively.",
"r": "Rule 112",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule112"
},
{
"id": 20,
"t": "attitude",
"q": "A pedestrian is waiting at a zebra crossing. What should you do?",
"o": [
"Wave them across",
"Sound your horn so they know you're there",
"Flash your lights to invite them",
"Be ready to slow down or stop and give way"
],
"a": 3,
"e": "Give way to pedestrians waiting to cross, and don't wave, flash or hoot to invite them across.",
"r": "Rule 195",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule195"
},
{
"id": 21,
"t": "attitude",
"q": "What does the Highway Code say about throwing litter from a vehicle?",
"o": [
"Only passengers may do it",
"Allowed on motorways only",
"Allowed if it's biodegradable",
"You MUST NOT throw anything out of a vehicle"
],
"a": 3,
"e": "You MUST NOT throw anything out of a vehicle, such as food packaging, cigarette ends or cans.",
"r": "Rule 147",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule147"
},
{
"id": 22,
"t": "attitude",
"q": "A bus is signalling to pull away from a stop ahead. What should you do?",
"o": [
"Flash your lights",
"Speed up to pass it first",
"Give priority if you can do so safely",
"Sound your horn"
],
"a": 2,
"e": "Give priority to buses, coaches and trams when you can do so safely, especially when they signal to pull away.",
"r": "Rule 223",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule223"
},
{
"id": 23,
"t": "attitude",
"q": "A learner driver ahead is slow to move off at a junction. What should you do?",
"o": [
"Be patient",
"Sound your horn",
"Drive close behind to hurry them",
"Overtake on the junction"
],
"a": 0,
"e": "Be particularly patient with learner drivers and young drivers.",
"r": "Rule 217",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule217"
},
{
"id": 24,
"t": "attitude",
"q": "How should you treat the speed limit on a road?",
"o": [
"As the absolute maximum, not always a safe speed",
"As a target to reach",
"As a guide only",
"As a minimum speed"
],
"a": 0,
"e": "The speed limit is the absolute maximum, and doesn't mean it's safe to drive at that speed in all conditions.",
"r": "Rule 125",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule125"
},
{
"id": 25,
"t": "safety-vehicle",
"q": "What is the minimum legal tread depth for car tyres?",
"o": [
"1.6 mm",
"1 mm",
"3 mm",
"2 mm"
],
"a": 0,
"e": "Cars MUST have at least 1.6 mm of tread across the central three-quarters of the tread and around the whole circumference.",
"r": "Annex 6",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-6-vehicle-maintenance-safety-and-security"
},
{
"id": 26,
"t": "safety-vehicle",
"q": "When is the best time to check your tyre pressures?",
"o": [
"Straight after a long drive",
"When the tyres are cold, before a journey",
"Only at the MOT",
"When the tyres are hot"
],
"a": 1,
"e": "Check weekly, before your journey, when tyres are cold. Warm tyres can give a misleading reading.",
"r": "Annex 6",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-6-vehicle-maintenance-safety-and-security"
},
{
"id": 27,
"t": "safety-vehicle",
"q": "How often does the Highway Code suggest checking tyre pressures?",
"o": [
"Weekly",
"Every six months",
"Only when a warning light shows",
"Once a year"
],
"a": 0,
"e": "Tyre pressures: check weekly.",
"r": "Annex 6",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-6-vehicle-maintenance-safety-and-security"
},
{
"id": 28,
"t": "safety-vehicle",
"q": "Which of these MUST be kept clean and clear?",
"o": [
"The dashboard",
"Only the rear window",
"Lights, indicators, reflectors and number plates",
"Only the windscreen"
],
"a": 2,
"e": "Lights, indicators, reflectors and number plates MUST be kept clean and clear.",
"r": "Annex 6",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-6-vehicle-maintenance-safety-and-security"
},
{
"id": 29,
"t": "safety-vehicle",
"q": "A child is under 1.35 metres tall. What MUST they use in a car?",
"o": [
"A suitable child seat, booster seat or booster cushion",
"Nothing, if sitting in the back",
"A lap belt",
"An adult belt only"
],
"a": 0,
"e": "Children under 1.35 metres tall MUST use a child restraint suitable for their weight.",
"r": "Rule 100",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule100"
},
{
"id": 30,
"t": "safety-vehicle",
"q": "Who is responsible for making sure children under 14 wear a seat belt or child restraint?",
"o": [
"The driver",
"No one",
"The child",
"The child's parent, wherever they sit"
],
"a": 0,
"e": "The driver MUST ensure all children under 14 wear seat belts or sit in an approved child restraint.",
"r": "Rule 100",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule100"
},
{
"id": 31,
"t": "safety-vehicle",
"q": "Where MUST you NOT fit a rear-facing baby seat?",
"o": [
"In the rear seats",
"Behind the driver",
"In a seat protected by an active frontal airbag",
"Behind the front passenger"
],
"a": 2,
"e": "A rear-facing baby seat MUST NOT be fitted into a seat protected by an active frontal airbag.",
"r": "Rule 101",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule101"
},
{
"id": 32,
"t": "safety-vehicle",
"q": "You've parked to run into a shop. Can you leave the engine running?",
"o": [
"Yes, if the doors are locked",
"Yes, for under five minutes",
"Yes, in cold weather",
"No, you MUST NOT leave a parked vehicle unattended with the engine running"
],
"a": 3,
"e": "You MUST NOT leave a parked vehicle unattended with the engine running.",
"r": "Rule 123",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule123"
},
{
"id": 33,
"t": "safety-vehicle",
"q": "What should you do with luggage before you drive?",
"o": [
"Nothing, it doesn't matter",
"Pile it on the parcel shelf",
"Make sure it is securely stowed",
"Leave it loose on the back seat"
],
"a": 2,
"e": "Ensure that items of luggage are securely stowed.",
"r": "Annex 6",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-6-vehicle-maintenance-safety-and-security"
},
{
"id": 34,
"t": "safety-vehicle",
"q": "Which of these does the Highway Code suggest as a cheap deterrent to car thieves?",
"o": [
"Leaving the car unlocked",
"Leaving documents in the glovebox",
"Parking in dark areas",
"Etching your registration number on the windows"
],
"a": 3,
"e": "Consider having your registration number etched on all your car windows, a cheap and effective deterrent.",
"r": "Annex 6",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-6-vehicle-maintenance-safety-and-security"
},
{
"id": 35,
"t": "safety-vehicle",
"q": "Where should you keep your vehicle documents?",
"o": [
"Never leave them in the car",
"In the boot",
"Under the seat",
"In the glovebox"
],
"a": 0,
"e": "Never leave vehicle documents in the car.",
"r": "Annex 6",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-6-vehicle-maintenance-safety-and-security"
},
{
"id": 36,
"t": "safety-vehicle",
"q": "Your car's wheels are out of alignment. What might you notice?",
"o": [
"Brighter headlights",
"A louder horn",
"Better fuel economy",
"Excessive or uneven tyre wear"
],
"a": 3,
"e": "Excessive or uneven tyre wear may be caused by brake or suspension faults, or wheels out of alignment.",
"r": "Annex 6",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-6-vehicle-maintenance-safety-and-security"
},
{
"id": 37,
"t": "safety-margins",
"q": "What is the minimum gap to leave behind the vehicle in front on a high-speed road in good conditions?",
"o": [
"Three car lengths",
"Two seconds",
"One second",
"Five metres"
],
"a": 1,
"e": "Allow at least a two-second gap on high-speed roads and in tunnels where visibility is reduced.",
"r": "Rule 126",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule126"
},
{
"id": 38,
"t": "safety-margins",
"q": "How should your following gap change on wet roads?",
"o": [
"Stay the same",
"Be at least doubled",
"Increase by one second",
"Be halved"
],
"a": 1,
"e": "The gap should be at least doubled on wet roads.",
"r": "Rule 126",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule126"
},
{
"id": 39,
"t": "safety-margins",
"q": "How much greater can stopping distances be on icy roads?",
"o": [
"Twice as long",
"Three times greater",
"Up to ten times greater",
"No different with ABS"
],
"a": 2,
"e": "On icy or snowy roads stopping distances can be ten times greater than on dry roads.",
"r": "Rule 230",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule230"
},
{
"id": 40,
"t": "safety-margins",
"q": "You have to stop in a tunnel. How big a gap should you leave to the vehicle in front?",
"o": [
"1 metre",
"No gap needed",
"At least 5 metres",
"At least 20 metres"
],
"a": 2,
"e": "If you have to stop in a tunnel, leave at least a 5-metre gap.",
"r": "Rule 126",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule126"
},
{
"id": 41,
"t": "safety-margins",
"q": "In wet weather, compared with dry roads, stopping distances will be:",
"o": [
"At least double",
"Slightly shorter",
"About the same",
"Exactly 10% longer"
],
"a": 0,
"e": "In wet weather stopping distances will be at least double those on dry roads.",
"r": "Rule 227",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule227"
},
{
"id": 42,
"t": "safety-margins",
"q": "How should you drive on icy roads?",
"o": [
"At a slow speed in as high a gear as possible",
"In a low gear with firm braking",
"Using cruise control",
"Quickly to avoid getting stuck"
],
"a": 0,
"e": "Drive at a slow speed in as high a gear as possible; accelerate and brake very gently.",
"r": "Rule 231",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule231"
},
{
"id": 43,
"t": "safety-margins",
"q": "Which vehicles are most affected by strong winds?",
"o": [
"Small hatchbacks",
"Electric cars",
"Buses at stops",
"High-sided vehicles"
],
"a": 3,
"e": "High-sided vehicles are most affected by windy weather, but gusts can also affect cars, cyclists and riders.",
"r": "Rule 232",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule232"
},
{
"id": 44,
"t": "safety-margins",
"q": "What should you do before entering fog?",
"o": [
"Speed up to get through it",
"Follow the car in front closely",
"Check your mirrors then slow down",
"Switch on hazard lights and keep going"
],
"a": 2,
"e": "Before entering fog, check your mirrors then slow down.",
"r": "Rule 234",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule234"
},
{
"id": 45,
"t": "safety-margins",
"q": "Why can following another car's rear lights in fog be dangerous?",
"o": [
"They are always too dim",
"They switch off in fog",
"They make you drive too slowly",
"They can give a false sense of security"
],
"a": 3,
"e": "Rear lights can give a false sense of security. Keep a safe distance.",
"r": "Rule 235",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule235"
},
{
"id": 46,
"t": "safety-margins",
"q": "Which places does the Highway Code warn can expose you to sudden strong crosswinds?",
"o": [
"Bridges and gaps in hedges",
"Petrol stations",
"Tunnels and car parks",
"Town centres"
],
"a": 0,
"e": "Strong gusts can happen on open roads, or when passing bridges or gaps in hedges.",
"r": "Rule 232",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule232"
},
{
"id": 47,
"t": "safety-margins",
"q": "Your car has ABS. What does that mean for stopping distance?",
"o": [
"You can brake later",
"Don't assume it will stop in a shorter distance",
"It always stops in a shorter distance",
"It works only on ice"
],
"a": 1,
"e": "ABS should help you keep steering control, but don't assume a car with ABS will stop in a shorter distance.",
"r": "Rule 120",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule120"
},
{
"id": 48,
"t": "safety-margins",
"q": "In very windy weather, when should you keep well back from a motorcyclist?",
"o": [
"Never",
"When they're turning left",
"When they're overtaking a high-sided vehicle",
"When they're stopped at lights"
],
"a": 2,
"e": "Motorcyclists are particularly affected by turbulence, so keep well back when they overtake a high-sided vehicle.",
"r": "Rule 233",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule233"
},
{
"id": 49,
"t": "hazard-awareness",
"q": "When may you use hazard warning lights while driving?",
"o": [
"When parking on double yellow lines",
"When towing another car",
"On a motorway or unrestricted dual carriageway to warn of a hazard ahead",
"When driving slowly in town"
],
"a": 2,
"e": "You MUST NOT use them while driving unless on a motorway or unrestricted dual carriageway to warn drivers behind of a hazard ahead.",
"r": "Rule 116",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule116"
},
{
"id": 50,
"t": "hazard-awareness",
"q": "You pass a parked ice cream van. What should you look out for?",
"o": [
"Low fuel",
"Speed cameras",
"Cyclists overtaking you",
"Children stepping into the road"
],
"a": 3,
"e": "Take extra care passing parked vehicles, especially ice cream vans; children are more interested in ice cream than traffic.",
"r": "Rule 206",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule206"
},
{
"id": 51,
"t": "hazard-awareness",
"q": "A stationary bus is showing a 'School Bus' sign. What should you do?",
"o": [
"Overtake quickly",
"Sound your horn and pass",
"Drive carefully and slowly as children may be getting on or off",
"Flash your lights"
],
"a": 2,
"e": "Drive carefully and slowly past a stationary 'School Bus', as children may be getting on or off.",
"r": "Rule 209",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule209"
},
{
"id": 52,
"t": "hazard-awareness",
"q": "A flashing amber light shows below a 'School' warning sign. What does it mean?",
"o": [
"Speed cameras are active",
"Children may be crossing the road ahead",
"The school is closed",
"Road works ahead"
],
"a": 1,
"e": "It tells you there may be children crossing ahead. Drive very slowly until you are clear of the area.",
"r": "Rule 208",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule208"
},
{
"id": 53,
"t": "hazard-awareness",
"q": "Another car is indicating left as it approaches a junction. What should you bear in mind?",
"o": [
"It wants you to overtake",
"It is about to stop",
"It will definitely turn",
"The indicator may not have been cancelled"
],
"a": 3,
"e": "Be aware that an indicator on another vehicle may not have been cancelled.",
"r": "Rule 104",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule104"
},
{
"id": 54,
"t": "hazard-awareness",
"q": "On a residential street, which hazard does the Highway Code highlight?",
"o": [
"Low bridges",
"Motorway merges",
"Car doors opening",
"Level crossings"
],
"a": 2,
"e": "Look out for vehicles emerging from driveways, vehicles moving off, car doors opening and pedestrians.",
"r": "Rule 152",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule152"
},
{
"id": 55,
"t": "hazard-awareness",
"q": "On a country road, what should you be prepared for?",
"o": [
"Horse riders, slow farm vehicles or mud on the road",
"Box junctions",
"Bus lanes",
"Trams"
],
"a": 0,
"e": "Be prepared for pedestrians, horse riders, cyclists, slow-moving farm vehicles or mud on the road.",
"r": "Rule 154",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule154"
},
{
"id": 56,
"t": "hazard-awareness",
"q": "You see emergency vehicles with flashing lights in the distance on a motorway. What should you expect?",
"o": [
"A speed check",
"There may be an incident ahead",
"Nothing, keep your speed",
"The road is closing tonight"
],
"a": 1,
"e": "Be aware there may be an incident ahead. Slow down and be prepared to change lane or stop.",
"r": "Rule 281",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule281"
},
{
"id": 57,
"t": "hazard-awareness",
"q": "Which colours of flashing light might emergency vehicles use?",
"o": [
"Purple",
"White only",
"Yellow only",
"Blue, red or green"
],
"a": 3,
"e": "Look and listen for emergency vehicles using flashing blue, red or green lights.",
"r": "Rule 219",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule219"
},
{
"id": 58,
"t": "hazard-awareness",
"q": "A vehicle ahead shows a flashing amber beacon. What does it usually warn of?",
"o": [
"An emergency doctor",
"A taxi for hire",
"A slow-moving or stationary vehicle",
"A learner driver"
],
"a": 2,
"e": "Flashing amber beacons warn of a slow-moving or stationary vehicle, such as a gritter or recovery truck.",
"r": "Rule 225",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule225"
},
{
"id": 59,
"t": "hazard-awareness",
"q": "Why should you take extra care passing bus and tram stops?",
"o": [
"Drivers must stop there",
"Pedestrians may emerge suddenly into the road",
"They have speed bumps",
"Buses always pull out"
],
"a": 1,
"e": "Drive carefully past bus and tram stops; pedestrians may emerge suddenly into the road.",
"r": "Rule 206",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule206"
},
{
"id": 60,
"t": "hazard-awareness",
"q": "A 'Road Works Ahead' sign is displayed. What MUST you not do?",
"o": [
"Exceed any temporary maximum speed limit",
"Use your mirrors",
"Slow down",
"Keep a safe distance"
],
"a": 0,
"e": "You MUST NOT exceed any temporary maximum speed limit at road works.",
"r": "Rule 288",
"u": "https://www.gov.uk/guidance/the-highway-code/road-works-level-crossings-and-tramways-288-to-307#rule288"
},
{
"id": 61,
"t": "hazard-awareness",
"q": "When passing an incident on the other side of a dual carriageway, what should you do?",
"o": [
"Stay alert and don't slow down unnecessarily",
"Slow down to look",
"Take a photo",
"Stop on the verge"
],
"a": 0,
"e": "Remain alert and do not slow down unnecessarily, for example if an incident is on the other side of a dual carriageway.",
"r": "Rule 282",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule282"
},
{
"id": 62,
"t": "vulnerable",
"q": "Under the Highway Code's hierarchy of road users, who has the greatest responsibility to reduce danger?",
"o": [
"Those in charge of vehicles that can cause the greatest harm",
"Pedestrians",
"Cyclists",
"Everyone equally"
],
"a": 0,
"e": "Those in charge of vehicles that can cause the greatest harm bear the greatest responsibility to reduce the danger they pose.",
"r": "Rule H1",
"u": "https://www.gov.uk/guidance/the-highway-code/introduction#ruleh1"
},
{
"id": 63,
"t": "vulnerable",
"q": "You're turning into a side road and a pedestrian is waiting to cross it. What should you do?",
"o": [
"Wave them back",
"Give way to them",
"Carry on, you have priority",
"Sound your horn"
],
"a": 1,
"e": "Give way to pedestrians crossing or waiting to cross a road into which or from which you are turning.",
"r": "Rule H2",
"u": "https://www.gov.uk/guidance/the-highway-code/introduction#ruleh2"
},
{
"id": 64,
"t": "vulnerable",
"q": "What is the minimum space to leave when overtaking a cyclist at speeds up to 30 mph?",
"o": [
"1.5 metres",
"0.5 metres",
"3 metres",
"1 metre"
],
"a": 0,
"e": "Leave at least 1.5 metres when overtaking cyclists at speeds of up to 30 mph, and more at higher speeds.",
"r": "Rule 163",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule163"
},
{
"id": 65,
"t": "vulnerable",
"q": "You see a horse on the road. What is the maximum speed you should slow down to?",
"o": [
"20 mph",
"10 mph",
"15 mph",
"5 mph"
],
"a": 1,
"e": "When you see a horse on a road, slow down to a maximum of 10 mph.",
"r": "Rule 215",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule215"
},
{
"id": 66,
"t": "vulnerable",
"q": "How much space should you leave when passing a horse rider?",
"o": [
"At least 50 cm",
"At least 1 metre",
"At least 5 metres",
"At least 2 metres"
],
"a": 3,
"e": "Pass horse riders and horse-drawn vehicles at speeds under 10 mph, allowing at least 2 metres of space.",
"r": "Rule 163",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule163"
},
{
"id": 67,
"t": "vulnerable",
"q": "Which group does the Highway Code list as most at risk from road traffic?",
"o": [
"Taxi drivers",
"Lorry drivers",
"Pedestrians, cyclists, horse riders and motorcyclists",
"Bus passengers"
],
"a": 2,
"e": "The road users most at risk include pedestrians, cyclists, horse riders and motorcyclists.",
"r": "Rule 204",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule204"
},
{
"id": 68,
"t": "vulnerable",
"q": "A pedestrian is carrying a white cane with a red band. What does this tell you?",
"o": [
"They may be deaf as well as blind",
"They are a school crossing patrol",
"They are a tourist",
"They are injured"
],
"a": 0,
"e": "A white cane with a red band means the person may be deaf as well as blind.",
"r": "Rule 207",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule207"
},
{
"id": 69,
"t": "vulnerable",
"q": "Why might a cyclist ride in the centre of the lane on a narrow road?",
"o": [
"To annoy drivers",
"They are lost",
"It's illegal and you should hoot",
"It can be safer for them in some situations"
],
"a": 3,
"e": "On narrow roads, quiet streets, junctions and in slower traffic, cyclists may ride in the centre of the lane.",
"r": "Rule 213",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule213"
},
{
"id": 70,
"t": "vulnerable",
"q": "At a pelican crossing the amber light is flashing and someone is still crossing. What should you do?",
"o": [
"Go, the light isn't red",
"Give way to them",
"Edge forward",
"Sound your horn"
],
"a": 1,
"e": "When the amber light is flashing, you MUST give way to any pedestrians on the crossing.",
"r": "Rule 196",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule196"
},
{
"id": 71,
"t": "vulnerable",
"q": "A school crossing patrol shows a 'Stop for children' sign. What MUST you do?",
"o": [
"Stop",
"Sound your horn",
"Drive round them",
"Slow down"
],
"a": 0,
"e": "You MUST stop when a school crossing patrol shows a 'Stop for children' sign.",
"r": "Rule 210",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule210"
},
{
"id": 72,
"t": "vulnerable",
"q": "Why does the Highway Code say speed matters so much around pedestrians?",
"o": [
"Speed doesn't matter in towns",
"Pedestrians always see you",
"Only lorries are dangerous",
"At 40 mph a car will probably kill a pedestrian it hits"
],
"a": 3,
"e": "At 40 mph your vehicle will probably kill any pedestrian it hits. At 20 mph the chance is far lower.",
"r": "Rule 207",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule207"
},
{
"id": 73,
"t": "vulnerable",
"q": "A cyclist is in a cycle lane next to you and you want to turn left. What should you do?",
"o": [
"Not cut across them",
"Speed up",
"Sound your horn first",
"Turn in front of them"
],
"a": 0,
"e": "Do not cut across cyclists going ahead when turning into or out of a junction.",
"r": "Rule H3",
"u": "https://www.gov.uk/guidance/the-highway-code/introduction#ruleh3"
},
{
"id": 74,
"t": "vulnerable",
"q": "How much room should you give a pedestrian walking in the road where there's no pavement?",
"o": [
"None if you slow down",
"Very little, they should move",
"Just 30 cm",
"At least as much as when overtaking a car"
],
"a": 3,
"e": "Give pedestrians walking in the road at least as much room as you would when overtaking a car.",
"r": "Rule 212",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule212"
},
{
"id": 75,
"t": "other-vehicles",
"q": "You are following a large lorry. Why should you drop back?",
"o": [
"To see further ahead and so the driver can see you in their mirrors",
"To read its number plate",
"Because lorries brake suddenly",
"To save fuel"
],
"a": 0,
"e": "Drop back to increase your view ahead and let the lorry driver see you in their mirrors.",
"r": "Rule 164",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule164"
},
{
"id": 76,
"t": "other-vehicles",
"q": "A long vehicle is turning at a junction and needs extra room. What should you do?",
"o": [
"Be prepared to stop and wait",
"Squeeze past on the inside",
"Overtake it",
"Sound your horn"
],
"a": 0,
"e": "Large vehicles may need extra space to turn. Be prepared to stop and wait.",
"r": "Rule 221",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule221"
},
{
"id": 77,
"t": "other-vehicles",
"q": "What is the maximum speed of powered wheelchairs and mobility scooters on the road?",
"o": [
"15 mph",
"4 mph",
"8 mph",
"12 mph"
],
"a": 2,
"e": "These small vehicles travel at a maximum speed of 8 mph (12 km/h).",
"r": "Rule 220",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule220"
},
{
"id": 78,
"t": "other-vehicles",
"q": "Why do trams need extra care?",
"o": [
"They stop often",
"They only run at night",
"They have no brakes",
"They move quickly but silently and can't steer to avoid you"
],
"a": 3,
"e": "Trams move quickly but silently and cannot steer to avoid you.",
"r": "Rule 224",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule224"
},
{
"id": 79,
"t": "other-vehicles",
"q": "May you drive in a lane reserved for trams?",
"o": [
"Only motorcycles may",
"No, you MUST NOT enter a route reserved for trams",
"Yes, outside rush hour",
"Yes, if it's empty"
],
"a": 1,
"e": "You MUST NOT enter a road, lane or other route reserved for trams.",
"r": "Rule 300",
"u": "https://www.gov.uk/guidance/the-highway-code/road-works-level-crossings-and-tramways-288-to-307#rule300"
},
{
"id": 80,
"t": "other-vehicles",
"q": "At a junction with tram tracks, who should you give way to?",
"o": [
"Nobody",
"Buses only",
"Trams, always",
"Cars only"
],
"a": 2,
"e": "Always give way to trams.",
"r": "Rule 301",
"u": "https://www.gov.uk/guidance/the-highway-code/road-works-level-crossings-and-tramways-288-to-307#rule301"
},
{
"id": 81,
"t": "other-vehicles",
"q": "Why should you be patient behind a lorry on a single carriageway?",
"o": [
"They must stop every mile",
"Larger vehicles have lower speed limits than cars",
"They can't use mirrors",
"Lorries are always faulty"
],
"a": 1,
"e": "Larger vehicles are subject to lower speed limits than cars and many have speed limiters.",
"r": "Rule 222",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule222"
},
{
"id": 82,
"t": "other-vehicles",
"q": "Why are cyclists and motorcyclists at extra risk near tram tracks?",
"o": [
"Tram stops have no lights",
"They are not allowed there",
"The rails can be slippery, especially when wet",
"Trams flash them"
],
"a": 2,
"e": "Cyclists and motorcyclists should take extra care near or crossing tracks, especially if the rails are wet.",
"r": "Rule 306",
"u": "https://www.gov.uk/guidance/the-highway-code/road-works-level-crossings-and-tramways-288-to-307#rule306"
},
{
"id": 83,
"t": "other-vehicles",
"q": "Which of these might show a flashing amber beacon?",
"o": [
"A learner car",
"A taxi",
"An ambulance",
"A salt spreader"
],
"a": 3,
"e": "Flashing amber beacons are used by slow vehicles such as traffic officer vehicles, salt spreaders, snow ploughs and recovery vehicles.",
"r": "Rule 225",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule225"
},
{
"id": 84,
"t": "other-vehicles",
"q": "When are motorcyclists and cyclists especially hard to see?",
"o": [
"Only at night",
"Never in daylight",
"When filtering through traffic or coming out of junctions",
"Only in the rain"
],
"a": 2,
"e": "They are hard to see when waiting alongside you, coming from behind, at junctions, roundabouts, or filtering.",
"r": "Rule 211",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule211"
},
{
"id": 85,
"t": "other-vehicles",
"q": "What should you be aware of when following a bus or articulated lorry?",
"o": [
"It must give way to you",
"The driver may not be able to see you in their mirrors",
"It always turns left",
"It can't brake quickly"
],
"a": 1,
"e": "Be aware the driver of a large vehicle may not be able to see you in their mirrors.",
"r": "Rule 221",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule221"
},
{
"id": 86,
"t": "other-vehicles",
"q": "A dual carriageway has a speed limit over 50 mph. What MUST a powered mobility scooter on it display?",
"o": [
"Hazard lights only",
"A flashing amber beacon",
"L plates",
"Nothing"
],
"a": 1,
"e": "On dual carriageways where the limit exceeds 50 mph they MUST have a flashing amber beacon.",
"r": "Rule 220",
"u": "https://www.gov.uk/guidance/the-highway-code/road-users-requiring-extra-care-204-to-225#rule220"
},
{
"id": 87,
"t": "vehicle-handling",
"q": "What is the safest way to brake in normal conditions?",
"o": [
"Late and hard",
"Using the handbrake",
"Early and lightly",
"Pumping the pedal"
],
"a": 2,
"e": "Brake early and lightly, then more firmly as you begin to stop.",
"r": "Rule 117",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule117"
},
{
"id": 88,
"t": "vehicle-handling",
"q": "In an emergency stop, what should you try to avoid?",
"o": [
"Braking so harshly that you lock your wheels",
"Holding the steering wheel",
"Braking at all",
"Looking ahead"
],
"a": 0,
"e": "Brake immediately, but try to avoid braking so harshly that you lock your wheels.",
"r": "Rule 118",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule118"
},
{
"id": 89,
"t": "vehicle-handling",
"q": "The rear of your car skids to the right. Which way should you steer?",
"o": [
"Straight ahead",
"Brake hard and don't steer",
"Left",
"Right"
],
"a": 3,
"e": "Steer in the direction of the skid. If the rear skids right, steer right.",
"r": "Rule 119",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule119"
},
{
"id": 90,
"t": "vehicle-handling",
"q": "What usually causes a skid?",
"o": [
"Using dipped headlights",
"Wearing a seat belt",
"Low fuel",
"Harsh braking, accelerating or steering, or driving too fast for the conditions"
],
"a": 3,
"e": "Skidding is usually caused by braking, accelerating or steering too harshly, or going too fast for the conditions.",
"r": "Rule 119",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule119"
},
{
"id": 91,
"t": "vehicle-handling",
"q": "You've just driven through deep water. What should you do?",
"o": [
"Drive fast to dry them",
"Test your brakes gently at the first safe opportunity",
"Nothing",
"Brake hard to dry the brakes"
],
"a": 1,
"e": "Brakes may be less effective. Test them gently at the first safe opportunity.",
"r": "Rule 121",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule121"
},
{
"id": 92,
"t": "vehicle-handling",
"q": "Why is coasting (driving in neutral or with the clutch down) dangerous?",
"o": [
"It uses more fuel",
"It's only illegal at night",
"It removes engine braking and reduces control",
"It damages the tyres"
],
"a": 2,
"e": "Coasting reduces control because engine braking is eliminated and speed downhill increases quickly.",
"r": "Rule 122",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule122"
},
{
"id": 93,
"t": "vehicle-handling",
"q": "In an emergency, how should you brake in a car with ABS?",
"o": [
"Pump the brake pedal",
"Apply the footbrake firmly and keep the pressure on",
"Brake gently",
"Use the handbrake"
],
"a": 1,
"e": "Apply the footbrake firmly; do not release the pressure until the car has slowed to the desired speed.",
"r": "Rule 120",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule120"
},
{
"id": 94,
"t": "vehicle-handling",
"q": "Where possible, how should you hold the steering wheel?",
"o": [
"Only with your fingertips",
"With both hands",
"With your knee",
"One hand, resting the other on the gear stick"
],
"a": 1,
"e": "Drive or ride with both hands on the wheel or handlebars where possible.",
"r": "Rule 160",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule160"
},
{
"id": 95,
"t": "vehicle-handling",
"q": "On a right-hand bend, where should you position the car?",
"o": [
"In the middle of the road",
"Keep well to the left",
"Close to the centre line",
"On the verge"
],
"a": 1,
"e": "Keep well to the left on right-hand bends to improve your view and avoid oncoming traffic.",
"r": "Rule 160",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule160"
},
{
"id": 96,
"t": "vehicle-handling",
"q": "Before setting off on a frosty morning, what MUST you do?",
"o": [
"Be able to see, so clear all snow and ice from all windows",
"Clear just a small patch of the windscreen",
"Rely on the heater",
"Drive with your head out of the window"
],
"a": 0,
"e": "You MUST be able to see, so clear all snow and ice from all your windows.",
"r": "Rule 229",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule229"
},
{
"id": 97,
"t": "vehicle-handling",
"q": "Visibility is seriously reduced. What does this generally mean?",
"o": [
"You can't see for more than 500 metres",
"It's dusk",
"It's raining lightly",
"You can't see for more than 100 metres"
],
"a": 3,
"e": "Seriously reduced visibility generally means when you cannot see for more than 100 metres; you MUST use headlights.",
"r": "Rule 226",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule226"
},
{
"id": 98,
"t": "vehicle-handling",
"q": "When MUST you switch off your fog lights?",
"o": [
"After 10 minutes",
"Never",
"Only when you park",
"When visibility improves"
],
"a": 3,
"e": "Fog lights dazzle others and can hide your brake lights. You MUST switch them off when visibility improves.",
"r": "Rule 236",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule236"
},
{
"id": 99,
"t": "vehicle-handling",
"q": "In hot weather, what can happen to the road surface?",
"o": [
"It becomes rougher",
"It may become soft, or slippery if it rains after a dry spell",
"It becomes grippier",
"Nothing"
],
"a": 1,
"e": "The road surface may become soft, or slippery if it rains after a dry spell.",
"r": "Rule 237",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule237"
},
{
"id": 100,
"t": "vehicle-handling",
"q": "You're in a stationary queue at night. How can you reduce glare for drivers behind?",
"o": [
"Flash your hazards",
"Switch on fog lights",
"Keep your foot on the brake",
"Apply the parking brake and take your foot off the footbrake"
],
"a": 3,
"e": "Apply the parking brake and, once traffic behind has stopped, take your foot off the footbrake to turn off the brake lights.",
"r": "Rule 114",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule114"
},
{
"id": 101,
"t": "motorway",
"q": "When can a learner car driver drive on a motorway?",
"o": [
"Never",
"At night only",
"With any full licence holder over 21",
"With an approved driving instructor in a dual-control car showing L plates"
],
"a": 3,
"e": "Learners MUST NOT drive on a motorway unless with a DVSA Approved Driving Instructor in a dual-control car displaying L plates.",
"r": "Rule 253",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule253"
},
{
"id": 102,
"t": "motorway",
"q": "When joining a motorway from a slip road, who has priority?",
"o": [
"Whoever is faster",
"You do",
"Lorries",
"Traffic already on the motorway"
],
"a": 3,
"e": "Give priority to traffic already on the motorway and match your speed to fit safely into the left lane.",
"r": "Rule 259",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule259"
},
{
"id": 103,
"t": "motorway",
"q": "Which lane should you normally use on a motorway?",
"o": [
"The left lane, unless overtaking",
"The middle lane",
"The right lane",
"Any lane"
],
"a": 0,
"e": "Keep in the left lane unless overtaking, and return to it when it's safe.",
"r": "Rule 264",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule264"
},
{
"id": 104,
"t": "motorway",
"q": "On a motorway, on which side should you overtake?",
"o": [
"Only on the right",
"Only on the left",
"Left or right",
"Wherever there's space"
],
"a": 0,
"e": "Overtake only on the right. Do not overtake on the left or move to a lane on your left to overtake.",
"r": "Rule 267",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule267"
},
{
"id": 105,
"t": "motorway",
"q": "A red X is shown above your lane on a motorway. What does it mean?",
"o": [
"Reduce speed to 50 mph",
"Lane opening soon",
"The lane is closed, and you MUST NOT drive in it",
"The lane is for lorries"
],
"a": 2,
"e": "A red X identifies a closed lane. You MUST NOT drive in a closed lane.",
"r": "Rule 258",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule258"
},
{
"id": 106,
"t": "motorway",
"q": "What should you do when you see amber flashing lights on a motorway?",
"o": [
"Speed up",
"Stop immediately",
"Move to the hard shoulder",
"Reduce your speed and be prepared for a hazard"
],
"a": 3,
"e": "Amber flashing lights warn of a hazard ahead. Reduce your speed and be ready.",
"r": "Rule 257",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule257"
},
{
"id": 107,
"t": "motorway",
"q": "You've missed your exit on a motorway. What should you do?",
"o": [
"Carry on to the next exit",
"Cross the central reservation",
"Stop and wait",
"Reverse on the hard shoulder"
],
"a": 0,
"e": "You MUST NOT reverse. If you've missed your exit, carry on to the next one.",
"r": "Rule 263",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule263"
},
{
"id": 108,
"t": "motorway",
"q": "When may you use the hard shoulder?",
"o": [
"For a quick rest",
"To overtake slow traffic",
"In an emergency or when directed by police, traffic officers or signs",
"To take a phone call"
],
"a": 2,
"e": "You MUST NOT use a hard shoulder except in an emergency or if directed to by police, traffic officers or a sign.",
"r": "Rule 269",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule269"
},
{
"id": 109,
"t": "motorway",
"q": "You're towing a trailer on a three-lane motorway. Which lane MUST you not use?",
"o": [
"The middle lane",
"The right-hand lane",
"The left lane",
"The slip road"
],
"a": 1,
"e": "The right-hand lane of a motorway with three or more lanes MUST NOT be used by a vehicle drawing a trailer.",
"r": "Rule 265",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule265"
},
{
"id": 110,
"t": "motorway",
"q": "How are motorway emergency areas marked?",
"o": [
"Blue signs with an orange SOS telephone symbol",
"Green signs with a white P",
"Red signs",
"Brown signs"
],
"a": 0,
"e": "Emergency areas are marked by blue signs with an orange SOS telephone symbol and may have orange surfacing.",
"r": "Rule 270",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule270"
},
{
"id": 111,
"t": "motorway",
"q": "Leaving a motorway, why should you check your speedometer?",
"o": [
"Slip roads have no limit",
"Your speed may be higher than you realise",
"The speedo stops working",
"To save fuel"
],
"a": 1,
"e": "Your speed may be higher than you realise; 50 mph may feel like 30 mph.",
"r": "Rule 274",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule274"
},
{
"id": 112,
"t": "motorway",
"q": "May you stop on a motorway to make or take a phone call?",
"o": [
"No, except in an emergency",
"Yes, on a slip road",
"Yes, on the verge",
"Yes, on the hard shoulder"
],
"a": 0,
"e": "Do not stop on any part of a motorway to make or receive phone calls, except in an emergency.",
"r": "Rule 271",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule271"
},
{
"id": 113,
"t": "motorway",
"q": "What should you do well before reaching your motorway exit?",
"o": [
"Switch on hazard lights",
"Brake on the main carriageway",
"Move into the right-hand lane",
"Move into the left-hand lane"
],
"a": 3,
"e": "Watch for the signs, move into the left-hand lane well before your exit, signal left in good time.",
"r": "Rule 273",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule273"
},
{
"id": 114,
"t": "rules-of-road",
"q": "Unless signs say otherwise, what is the speed limit for a car on a road with street lights in England?",
"o": [
"20 mph",
"40 mph",
"30 mph",
"60 mph"
],
"a": 2,
"e": "A 30 mph limit generally applies to roads with street lights in England and Scotland (20 mph in Wales) unless signs show otherwise.",
"r": "Rule 124",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule124"
},
{
"id": 115,
"t": "rules-of-road",
"q": "What is the national speed limit for a car on a single carriageway?",
"o": [
"70 mph",
"50 mph",
"40 mph",
"60 mph"
],
"a": 3,
"e": "Cars and motorcycles: 60 mph on single carriageways.",
"r": "Rule 124",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule124"
},
{
"id": 116,
"t": "rules-of-road",
"q": "What is the national speed limit for a car on a dual carriageway?",
"o": [
"60 mph",
"80 mph",
"70 mph",
"50 mph"
],
"a": 2,
"e": "Cars and motorcycles: 70 mph on dual carriageways and motorways.",
"r": "Rule 124",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule124"
},
{
"id": 117,
"t": "rules-of-road",
"q": "In Wales, what speed limit generally applies on roads with street lights, unless signs show otherwise?",
"o": [
"25 mph",
"30 mph",
"20 mph",
"40 mph"
],
"a": 2,
"e": "In Wales the default limit on roads with street lights is 20 mph unless signs show otherwise.",
"r": "Rule 124",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule124"
},
{
"id": 118,
"t": "rules-of-road",
"q": "At a roundabout, who do you normally give priority to?",
"o": [
"Nobody",
"Whoever is biggest",
"Traffic approaching from your right",
"Traffic from the left"
],
"a": 2,
"e": "Give priority to traffic approaching from your right, unless signs, markings or lights say otherwise.",
"r": "Rule 185",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule185"
},
{
"id": 119,
"t": "rules-of-road",
"q": "When MUST you NOT enter a yellow box junction?",
"o": [
"When your exit road or lane is not clear",
"When the lights are green",
"When turning left",
"Never"
],
"a": 0,
"e": "You MUST NOT enter the box until your exit is clear (but you may wait in it to turn right if only oncoming traffic stops you).",
"r": "Rule 174",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule174"
},
{
"id": 120,
"t": "rules-of-road",
"q": "How close to a junction should you avoid parking, unless in an authorised bay?",
"o": [
"10 metres",
"2 metres",
"50 metres",
"5 metres"
],
"a": 0,
"e": "Do not park opposite or within 10 metres of a junction, except in an authorised parking space.",
"r": "Rule 243",
"u": "https://www.gov.uk/guidance/the-highway-code/waiting-and-parking-238-to-252#rule243"
},
{
"id": 121,
"t": "rules-of-road",
"q": "At night, which way MUST you not park on a road (outside a recognised parking space)?",
"o": [
"Close to the kerb",
"Under a street light",
"Facing the direction of traffic",
"Facing against the direction of traffic"
],
"a": 3,
"e": "You MUST NOT park on a road at night facing against the direction of traffic flow, unless in a recognised space.",
"r": "Rule 248",
"u": "https://www.gov.uk/guidance/the-highway-code/waiting-and-parking-238-to-252#rule248"
},
{
"id": 122,
"t": "rules-of-road",
"q": "When MUST you display parking lights when parked on a road at night?",
"o": [
"Only in fog",
"When the speed limit is greater than 30 mph",
"Always",
"Never"
],
"a": 1,
"e": "All vehicles MUST display parking lights when parked on a road or lay-by with a speed limit greater than 30 mph.",
"r": "Rule 249",
"u": "https://www.gov.uk/guidance/the-highway-code/waiting-and-parking-238-to-252#rule249"
},
{
"id": 123,
"t": "rules-of-road",
"q": "When MUST you not overtake?",
"o": [
"When the road is clear",
"On a one-way street",
"If you'd have to cross double white lines with a solid line nearest you",
"On a straight dual carriageway"
],
"a": 2,
"e": "You MUST NOT overtake if you'd have to cross or straddle double white lines with the solid line nearest to you.",
"r": "Rule 165",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule165"
},
{
"id": 124,
"t": "rules-of-road",
"q": "Which of these is a place NOT to overtake?",
"o": [
"The brow of a hill",
"A long straight",
"A dual carriageway",
"A motorway"
],
"a": 0,
"e": "Do not overtake where you can't see far enough ahead, such as at a bend, a hump bridge or the brow of a hill.",
"r": "Rule 166",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule166"
},
{
"id": 125,
"t": "rules-of-road",
"q": "At a junction with a 'Stop' sign and a solid white line, what MUST you do?",
"o": [
"Stop behind the line",
"Sound your horn",
"Give way only to the right",
"Slow down and go if clear"
],
"a": 0,
"e": "You MUST stop behind the line at a junction with a 'Stop' sign and a solid white line across the road.",
"r": "Rule 171",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule171"
},
{
"id": 126,
"t": "rules-of-road",
"q": "Between which times MUST you not use your horn while stationary in a built-up area (unless there's danger)?",
"o": [
"11.30pm and 7am",
"Midnight and 8am",
"10pm and 6am",
"9pm and 5am"
],
"a": 0,
"e": "You MUST NOT use your horn while stationary on a built-up road between 11.30pm and 7am, unless someone poses a danger.",
"r": "Rule 112",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule112"
},
{
"id": 127,
"t": "rules-of-road",
"q": "The broken white line in the centre of the road gets longer with shorter gaps. What does it mean?",
"o": [
"The road is ending",
"There is a hazard ahead",
"You may overtake",
"A bus lane starts"
],
"a": 1,
"e": "When the centre line lengthens and the gaps shorten, it means there is a hazard ahead.",
"r": "Rule 127",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule127"
},
{
"id": 128,
"t": "rules-of-road",
"q": "You're taking the first exit at a roundabout. Normally, how should you signal and position?",
"o": [
"No signal, middle lane",
"Signal left, right-hand lane",
"Signal left, left-hand lane",
"Signal right, right-hand lane"
],
"a": 2,
"e": "For the first exit, signal left and approach in the left-hand lane, keeping left on the roundabout.",
"r": "Rule 186",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule186"
},
{
"id": 129,
"t": "rules-of-road",
"q": "Where MUST you not park, in London or Scotland (with limited exceptions)?",
"o": [
"In car parks",
"Partially or wholly on the pavement",
"In marked bays",
"On private driveways"
],
"a": 1,
"e": "You MUST NOT park partially or wholly on the pavement in London or Scotland.",
"r": "Rule 244",
"u": "https://www.gov.uk/guidance/the-highway-code/waiting-and-parking-238-to-252#rule244"
},
{
"id": 130,
"t": "signs",
"q": "What do signs with red circles mostly do?",
"o": [
"Prohibit something",
"Give directions",
"Show tourist sites",
"Give warnings"
],
"a": 0,
"e": "Signs with red circles are mostly prohibitive.",
"r": "Traffic signs",
"u": "https://www.gov.uk/guidance/the-highway-code/traffic-signs"
},
{
"id": 131,
"t": "signs",
"q": "What shape are most warning signs?",
"o": [
"Octagonal",
"Rectangular",
"Circular",
"Triangular"
],
"a": 3,
"e": "Warning signs are mostly triangular.",
"r": "Traffic signs",
"u": "https://www.gov.uk/guidance/the-highway-code/traffic-signs"
},
{
"id": 132,
"t": "signs",
"q": "What do blue circular signs with no red border mostly do?",
"o": [
"Warn of hazards",
"Prohibit",
"Give a positive instruction",
"Show distances"
],
"a": 2,
"e": "Signs with blue circles but no red border mostly give a positive instruction.",
"r": "Traffic signs",
"u": "https://www.gov.uk/guidance/the-highway-code/traffic-signs"
},
{
"id": 133,
"t": "signs",
"q": "What colour background do motorway direction signs have?",
"o": [
"White",
"Blue",
"Brown",
"Green"
],
"a": 1,
"e": "Signs on motorways have blue backgrounds.",
"r": "Traffic signs",
"u": "https://www.gov.uk/guidance/the-highway-code/traffic-signs"
},
{
"id": 134,
"t": "signs",
"q": "What colour background do primary route direction signs have?",
"o": [
"Blue",
"Green",
"Yellow",
"Brown"
],
"a": 1,
"e": "Signs on primary routes have green backgrounds.",
"r": "Traffic signs",
"u": "https://www.gov.uk/guidance/the-highway-code/traffic-signs"
},
{
"id": 135,
"t": "signs",
"q": "What do brown panels on direction signs show?",
"o": [
"Local roads",
"Routes to tourist attractions",
"Motorways",
"Diversions"
],
"a": 1,
"e": "Brown panels show the route to tourist attractions.",
"r": "Traffic signs",
"u": "https://www.gov.uk/guidance/the-highway-code/traffic-signs"
},
{
"id": 136,
"t": "signs",
"q": "What shape are most direction signs?",
"o": [
"Triangular",
"Circular",
"Rectangular",
"Diamond"
],
"a": 2,
"e": "Direction signs are mostly rectangular.",
"r": "Traffic signs",
"u": "https://www.gov.uk/guidance/the-highway-code/traffic-signs"
},
{
"id": 137,
"t": "signs",
"q": "What does a steady AMBER traffic light mean?",
"o": [
"Go faster",
"Give way to the right",
"Stop at the stop line, unless you've crossed it or are too close to stop safely",
"Get ready to go"
],
"a": 2,
"e": "AMBER means stop at the stop line. You may go on only if you've crossed it or are so close that pulling up might cause a collision.",
"r": "Light signals",
"u": "https://www.gov.uk/guidance/the-highway-code/light-signals-controlling-traffic"
},
{
"id": 138,
"t": "signs",
"q": "What does RED AND AMBER together mean?",
"o": [
"Go",
"Turn left only",
"Stop: do not pass through or start until GREEN shows",
"Proceed with caution"
],
"a": 2,
"e": "RED AND AMBER also means stop. Do not pass through or start until GREEN shows.",
"r": "Light signals",
"u": "https://www.gov.uk/guidance/the-highway-code/light-signals-controlling-traffic"
},
{
"id": 139,
"t": "signs",
"q": "What does a GREEN traffic light mean?",
"o": [
"Speed up",
"You must go",
"Pedestrians first",
"You may go on if the way is clear"
],
"a": 3,
"e": "GREEN means you may go on if the way is clear, taking care and giving way to crossing pedestrians when turning.",
"r": "Light signals",
"u": "https://www.gov.uk/guidance/the-highway-code/light-signals-controlling-traffic"
},
{
"id": 140,
"t": "signs",
"q": "What do double yellow lines along the edge of the road mean?",
"o": [
"Parking for 1 hour",
"Bus lane",
"No waiting at any time, unless signs show seasonal restrictions",
"Loading only"
],
"a": 2,
"e": "Double yellow lines mean no waiting at any time, unless signs indicate seasonal restrictions.",
"r": "Road markings",
"u": "https://www.gov.uk/guidance/the-highway-code/road-markings"
},
{
"id": 141,
"t": "signs",
"q": "What does a double red line on a Red Route mean?",
"o": [
"Parking for blue badge holders",
"No stopping at any time",
"Bus stop",
"Loading allowed"
],
"a": 1,
"e": "The double red line ALWAYS means no stopping at any time.",
"r": "Road markings",
"u": "https://www.gov.uk/guidance/the-highway-code/road-markings"
},
{
"id": 142,
"t": "signs",
"q": "What MUST you not do in the area covered by zig-zag lines at a pedestrian crossing?",
"o": [
"Drive",
"Use your mirrors",
"Park",
"Signal"
],
"a": 2,
"e": "You MUST NOT park on a crossing or in the area covered by the zig-zag lines.",
"r": "Rule 191",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule191"
},
{
"id": 143,
"t": "signs",
"q": "At a level crossing, twin red lights start flashing. What MUST you do?",
"o": [
"Speed across quickly",
"Edge forward",
"Stop: always obey the flashing red stop lights",
"Sound your horn"
],
"a": 2,
"e": "You MUST always obey the flashing red stop lights at a level crossing.",
"r": "Rule 293",
"u": "https://www.gov.uk/guidance/the-highway-code/road-works-level-crossings-and-tramways-288-to-307#rule293"
},
{
"id": 144,
"t": "signs",
"q": "A 'Give Way' junction has broken white lines across the road. What MUST you do?",
"o": [
"Speed up to join",
"Sound your horn",
"Give way to traffic on the main road",
"Stop every time"
],
"a": 2,
"e": "You MUST give way to traffic on the main road when emerging from a junction with broken white lines across it.",
"r": "Rule 172",
"u": "https://www.gov.uk/guidance/the-highway-code/using-the-road-159-to-203#rule172"
},
{
"id": 145,
"t": "signs",
"q": "An area of white chevrons on the road is bordered by solid white lines. When may you enter it?",
"o": [
"To park",
"To overtake",
"Whenever you like",
"Only in an emergency"
],
"a": 3,
"e": "If the chevron area is bordered by solid white lines you MUST NOT enter it except in an emergency.",
"r": "Rule 130",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule130"
},
{
"id": 146,
"t": "documents",
"q": "Who may supervise a learner car driver?",
"o": [
"Anyone over 18",
"Only a driving instructor",
"Someone at least 21 who has held a full licence for that type of car for at least three years",
"Anyone with a full licence"
],
"a": 2,
"e": "A supervisor MUST be at least 21 and have held a full licence for that type of car for at least three years.",
"r": "Annex 3",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-3-motor-vehicle-documentation-and-learner-driver-requirements"
},
{
"id": 147,
"t": "documents",
"q": "When does a car normally need its first MOT?",
"o": [
"After 30,000 miles",
"Three years from the date of first registration",
"After one year",
"After five years"
],
"a": 1,
"e": "Cars normally need an MOT three years from first registration and every year after that.",
"r": "Annex 3",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-3-motor-vehicle-documentation-and-learner-driver-requirements"
},
{
"id": 148,
"t": "documents",
"q": "Without an MOT when one is needed, when may you still drive the car?",
"o": [
"Within 10 miles of home",
"On weekends",
"To a pre-arranged MOT appointment or a garage for repairs needed for the test",
"Never"
],
"a": 2,
"e": "You may drive to a pre-arranged test appointment or to a garage for repairs required for the test.",
"r": "Annex 3",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-3-motor-vehicle-documentation-and-learner-driver-requirements"
},
{
"id": 149,
"t": "documents",
"q": "What is the minimum insurance cover required by law?",
"o": [
"Cover for injury or damage to a third party",
"Breakdown cover",
"Fully comprehensive",
"Fire and theft"
],
"a": 0,
"e": "Insurance MUST at least cover you for injury or damage to a third party.",
"r": "Annex 3",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-3-motor-vehicle-documentation-and-learner-driver-requirements"
},
{
"id": 150,
"t": "documents",
"q": "Where MUST L plates be visible on a learner's car?",
"o": [
"Front only",
"From in front and from behind",
"Rear only",
"On the roof"
],
"a": 1,
"e": "L plates MUST be clearly visible to others from in front of the vehicle and from behind.",
"r": "Annex 3",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-3-motor-vehicle-documentation-and-learner-driver-requirements"
},
{
"id": 151,
"t": "documents",
"q": "In Wales, which plates can a learner display?",
"o": [
"Green plates",
"Red D plates, red L plates, or both",
"P plates",
"Only L plates"
],
"a": 1,
"e": "In Wales, either red D plates, red L plates, or both, can be used.",
"r": "Annex 3",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-3-motor-vehicle-documentation-and-learner-driver-requirements"
},
{
"id": 152,
"t": "documents",
"q": "What should happen to L plates when someone with a full licence drives the car?",
"o": [
"They must be turned upside down",
"Swap them for P plates",
"Nothing",
"They should be removed or covered"
],
"a": 3,
"e": "Plates should be removed or covered when the car is not being driven by a learner.",
"r": "Annex 3",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-3-motor-vehicle-documentation-and-learner-driver-requirements"
},
{
"id": 153,
"t": "documents",
"q": "You want to keep an untaxed car off the road. What MUST you do?",
"o": [
"Tell your insurer only",
"Remove the number plates",
"Declare SORN to the DVLA",
"Nothing"
],
"a": 2,
"e": "If you keep a vehicle untaxed and off the public road you MUST declare SORN (Statutory Off Road Notification).",
"r": "Annex 3",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-3-motor-vehicle-documentation-and-learner-driver-requirements"
},
{
"id": 154,
"t": "documents",
"q": "A new driver gets 6 or more penalty points within 2 years of passing. What happens?",
"o": [
"A fine only",
"They must retake the theory test only",
"Nothing",
"Their licence is revoked"
],
"a": 3,
"e": "Under the new driver rules, 6 or more points within 2 years means the licence is revoked automatically.",
"r": "Annex 5",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-5-penalties"
},
{
"id": 155,
"t": "documents",
"q": "A police officer asks for your documents and you don't have them. Within how many days may you be asked to take them to a police station?",
"o": [
"Three days",
"Seven days",
"14 days",
"28 days"
],
"a": 1,
"e": "You may be asked to take them to a police station within seven days.",
"r": "Annex 3",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-3-motor-vehicle-documentation-and-learner-driver-requirements"
},
{
"id": 156,
"t": "documents",
"q": "If you change your name or address, who MUST you tell?",
"o": [
"Nobody",
"Your MOT garage",
"The DVLA",
"The council"
],
"a": 2,
"e": "You MUST inform the DVLA if you change your name and/or address.",
"r": "Annex 3",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-3-motor-vehicle-documentation-and-learner-driver-requirements"
},
{
"id": 157,
"t": "documents",
"q": "What does the Highway Code suggest new drivers consider to improve their skills, which could also save money on insurance?",
"o": [
"Pass Plus",
"Tinted windows",
"A motorway ban",
"A sports exhaust"
],
"a": 0,
"e": "Further training such as Pass Plus could save you money on insurance and reduce your risk.",
"r": "Annex 8",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-8-safety-code-for-new-drivers"
},
{
"id": 158,
"t": "incidents",
"q": "How far behind a broken-down car should you place a warning triangle on a normal road?",
"o": [
"At least 100 metres",
"At least 25 metres",
"At least 10 metres",
"At least 45 metres"
],
"a": 3,
"e": "Put a warning triangle at least 45 metres behind your broken-down vehicle on the same side of the road.",
"r": "Rule 276",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule276"
},
{
"id": 159,
"t": "incidents",
"q": "Should you use a warning triangle on a motorway?",
"o": [
"No, never use them on motorways",
"Yes, always",
"Only on the hard shoulder",
"Only at night"
],
"a": 0,
"e": "Warning triangles should never be used on motorways.",
"r": "Rule 276",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule276"
},
{
"id": 160,
"t": "incidents",
"q": "Your car breaks down on a motorway and you can stop safely on the left. How should you leave the car?",
"o": [
"By the side furthest from traffic",
"Through the boot",
"Stay in it with belts off",
"By the driver's door"
],
"a": 0,
"e": "Exit your vehicle by the side furthest from traffic, if it's safe, and make sure passengers do the same.",
"r": "Rule 277",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule277"
},
{
"id": 161,
"t": "incidents",
"q": "You've broken down in a live motorway lane and can't get out safely. What should you do?",
"o": [
"Put out a warning triangle",
"Stay in the car with seat belt and hazard lights on and call 999",
"Get out and push the car",
"Walk to an emergency phone"
],
"a": 1,
"e": "Stay in your vehicle, keep seat belts and hazard lights on, and call 999 immediately.",
"r": "Rule 277",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule277"
},
{
"id": 162,
"t": "incidents",
"q": "Something falls from your car onto a motorway. What should you do?",
"o": [
"Run back and get it",
"Ignore it",
"Flash your lights at others",
"Don't remove it yourself; stop somewhere safe and call 999"
],
"a": 3,
"e": "Do NOT remove the obstruction yourself. Stop in a place of relative safety and call 999.",
"r": "Rule 280",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule280"
},
{
"id": 163,
"t": "incidents",
"q": "At the scene of a collision, what should you ask drivers to do?",
"o": [
"Leave the scene",
"Move injured people",
"Sound their horns",
"Switch off their engines"
],
"a": 3,
"e": "Ask drivers to switch off their engines and drivers and passengers to stop smoking.",
"r": "Rule 283",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule283"
},
{
"id": 164,
"t": "incidents",
"q": "Someone is injured and trapped in a car after a crash, but there's no immediate danger. Should you move them?",
"o": [
"Only if they ask",
"Yes, straight away",
"No, don't move them unless they're in immediate danger",
"Yes, onto the hard shoulder"
],
"a": 2,
"e": "DO NOT move injured people from their vehicles unless they are in immediate danger.",
"r": "Rule 283",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule283"
},
{
"id": 165,
"t": "incidents",
"q": "An injured motorcyclist is wearing a helmet. What should you do?",
"o": [
"Don't remove it unless essential and you're trained",
"Tighten the strap",
"Remove it to help them breathe",
"Remove it for comfort"
],
"a": 0,
"e": "DO NOT remove a motorcyclist's helmet unless it is essential and you are trained to do so.",
"r": "Rule 283",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule283"
},
{
"id": 166,
"t": "incidents",
"q": "You're in a collision that damages another car, and you don't give your details at the scene. What MUST you do?",
"o": [
"Report it to the police as soon as reasonably practicable, within 24 hours",
"Nothing",
"Tell your insurer within a month",
"Write a note later"
],
"a": 0,
"e": "Report it to the police as soon as reasonably practicable, and in any case within 24 hours.",
"r": "Rule 286",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule286"
},
{
"id": 167,
"t": "incidents",
"q": "How long should you cool a burn with clean, cool water?",
"o": [
"Don't use water",
"At least 20 minutes",
"At least 1 hour",
"At least 2 minutes"
],
"a": 1,
"e": "Cool the burn for at least 20 minutes with plenty of clean, cool water.",
"r": "Annex 7",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-7-first-aid-on-the-road"
},
{
"id": 168,
"t": "incidents",
"q": "How should you deal with a bleeding wound with nothing embedded in it?",
"o": [
"Pour water on it",
"Apply a tourniquet first",
"Leave it to air",
"Apply firm pressure over the wound"
],
"a": 3,
"e": "If nothing is embedded, apply firm pressure over the wound to stem the flow of blood.",
"r": "Annex 7",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-7-first-aid-on-the-road"
},
{
"id": 169,
"t": "incidents",
"q": "Your car breaks down on a level crossing. What should you do first?",
"o": [
"Try to restart it",
"Push it across",
"Get everyone out and clear of the crossing",
"Phone a friend"
],
"a": 2,
"e": "Get everyone out of the vehicle and clear of the crossing immediately, then use a railway telephone if available.",
"r": "Rule 299",
"u": "https://www.gov.uk/guidance/the-highway-code/road-works-level-crossings-and-tramways-288-to-307#rule299"
},
{
"id": 170,
"t": "incidents",
"q": "A crash involves a vehicle carrying dangerous goods. What should you do?",
"o": [
"Move the vehicle",
"Keep well away, switch off engines, don't smoke and call 999",
"Try to rescue casualties straight away",
"Take photos close up"
],
"a": 1,
"e": "Keep well away and don't try to rescue casualties, as you could become one. Call 999 with as much information as possible.",
"r": "Rule 285",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule285"
},
{
"id": 171,
"t": "incidents",
"q": "What colour plates mark vehicles carrying dangerous goods in packages?",
"o": [
"Green plates",
"Blue plates",
"Plain orange reflective plates",
"Yellow and black"
],
"a": 2,
"e": "Vehicles carrying dangerous goods in packages are marked with plain orange reflective plates.",
"r": "Rule 284",
"u": "https://www.gov.uk/guidance/the-highway-code/breakdowns-and-incidents-274-to-287#rule284"
},
{
"id": 172,
"t": "vehicle-loading",
"q": "What MUST you not do when loading your car or trailer?",
"o": [
"Overload it",
"Use a roof box",
"Use tie-down straps",
"Carry passengers"
],
"a": 0,
"e": "You MUST NOT overload your vehicle or trailer.",
"r": "Rule 98",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule98"
},
{
"id": 173,
"t": "vehicle-loading",
"q": "Your caravan starts to snake. What should you do?",
"o": [
"Steer sharply",
"Ease off the accelerator and reduce speed gently",
"Speed up to straighten it",
"Brake hard"
],
"a": 1,
"e": "If the trailer starts to snake or swerve, ease off the accelerator and reduce speed gently.",
"r": "Rule 98",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule98"
},
{
"id": 174,
"t": "vehicle-loading",
"q": "Why does the date you passed your car test matter for towing?",
"o": [
"Only drivers who passed before 1990 can tow",
"Newer drivers can tow more",
"If you passed on or after 1 January 1997, there are limits on the trailer weight you can tow",
"It doesn't matter"
],
"a": 2,
"e": "If you passed your car test on or after 1 January 1997, you are restricted on the weight of trailer you can tow.",
"r": "Rule 98",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule98"
},
{
"id": 175,
"t": "vehicle-loading",
"q": "How heavy a trailer should you tow, at most?",
"o": [
"As heavy as the engine allows",
"No more than your vehicle manufacturer recommends",
"Twice the car's weight",
"Any weight under 3 tonnes"
],
"a": 1,
"e": "You should not tow a weight greater than that recommended by the manufacturer of your vehicle.",
"r": "Rule 98",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule98"
},
{
"id": 176,
"t": "vehicle-loading",
"q": "What MUST you check is working on a trailer before towing?",
"o": [
"The satellite navigation",
"The heated seats",
"The radio",
"The braking system and all lights"
],
"a": 3,
"e": "Make sure tyres are legal, the trailer braking system is in full working order and all trailer lights are working.",
"r": "Rule 98",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule98"
},
{
"id": 177,
"t": "vehicle-loading",
"q": "Where should children not sit in an estate car or hatchback?",
"o": [
"Behind the driver",
"In a booster seat",
"Behind the rear seats, unless a special child seat is fitted",
"In the rear seats"
],
"a": 2,
"e": "Children should not sit behind the rear seats in an estate or hatchback unless a special child seat is fitted.",
"r": "Rule 102",
"u": "https://www.gov.uk/guidance/the-highway-code/rules-for-drivers-and-motorcyclists-89-to-102#rule102"
},
{
"id": 178,
"t": "vehicle-loading",
"q": "Your car is heavily loaded. What might you need to adjust to avoid dazzling others?",
"o": [
"The headlight aim",
"The horn",
"The mirrors only",
"The seat height"
],
"a": 0,
"e": "Lights MUST be properly adjusted to avoid dazzling others; extra attention is needed if the vehicle is heavily loaded.",
"r": "Annex 6",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-6-vehicle-maintenance-safety-and-security"
},
{
"id": 179,
"t": "vehicle-loading",
"q": "Which motorway lane MUST you not use when towing a caravan on a motorway with three or more lanes?",
"o": [
"The left lane",
"The middle lane",
"Any lane is fine",
"The right-hand lane"
],
"a": 3,
"e": "Vehicles drawing a trailer MUST NOT use the right-hand lane of a motorway with three or more lanes.",
"r": "Rule 265",
"u": "https://www.gov.uk/guidance/the-highway-code/motorways-253-to-273#rule265"
},
{
"id": 180,
"t": "vehicle-loading",
"q": "What happens to your brakes and steering if your tyres are badly under-inflated?",
"o": [
"They improve",
"They are adversely affected",
"Only the brakes improve",
"Nothing changes"
],
"a": 1,
"e": "Brakes and steering are adversely affected by under-inflated or over-inflated tyres.",
"r": "Annex 6",
"u": "https://www.gov.uk/guidance/the-highway-code/annex-6-vehicle-maintenance-safety-and-security"
},
{
"id": 181,
"t": "vehicle-loading",
"q": "What is the national speed limit for a car towing a caravan on a motorway?",
"o": [
"40 mph",
"50 mph",
"60 mph",
"70 mph"
],
"a": 2,
"e": "Cars towing caravans or trailers: 60 mph on dual carriageways and motorways, 50 mph on single carriageways.",
"r": "Rule 124",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule124"
},
{
"id": 182,
"t": "vehicle-loading",
"q": "What is the national speed limit for a car towing a trailer on a single carriageway?",
"o": [
"50 mph",
"60 mph",
"40 mph",
"70 mph"
],
"a": 0,
"e": "Cars towing caravans or trailers: 50 mph on single carriageways.",
"r": "Rule 124",
"u": "https://www.gov.uk/guidance/the-highway-code/general-rules-techniques-and-advice-for-all-drivers-and-riders-103-to-158#rule124"
},
{
"id": 183,
"t": "vehicle-loading",
"q": "Snow is lying on your car roof. What should you do before you drive?",
"o": [
"Leave it, it'll blow off",
"Only clear the windscreen",
"Drive fast to clear it",
"Remove all snow that might fall off into the path of others"
],
"a": 3,
"e": "Remove all snow that might fall off into the path of other road users.",
"r": "Rule 229",
"u": "https://www.gov.uk/guidance/the-highway-code/driving-in-adverse-weather-conditions-226-to-237#rule229"
}
];
